import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, effect, inject, input, linkedSignal } from "@angular/core";

import { MessageService } from "../../../services/messageservice";

@Component({
  selector: "filter-bar",
  templateUrl: "filter-bar.html",
  styleUrl: "filter-bar.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class FilterBar {
  private msgsrv = inject(MessageService);

  readonly filterTitle = input.required<string>();
  readonly filterClassActive = input.required<string>();
  readonly filterType = input.required<string>();
  readonly filterValue = input.required<string>();
  readonly filterDefaultActive = input.required<boolean>();
  readonly filterIcon = input("");
  readonly filterColor = input("");

  protected filterBarActive = linkedSignal(() => this.filterDefaultActive());

  constructor() {
    effect(() => {
      const msg = { type: this.filterType(), value: this.filterValue() };

      if (this.filterBarActive()) {
        this.msgsrv.enableFilter(msg);
      } else {
        this.msgsrv.disableFilter(msg);
      }
    });
  }

  protected toggleFilter = () => this.filterBarActive.update((value) => !value);

  reset() {
    this.filterBarActive.set(this.filterDefaultActive());
  }
}
